'use client';
import { useSyncExternalStore } from 'react';
import type { Lang, T } from '../data';

// Langue : ?lang=en dans l'URL (lien direct pour candidatures), sinon localStorage, sinon FR.
const listeners = new Set<() => void>();

function read(): Lang {
    const q = new URLSearchParams(window.location.search).get('lang');
    if (q === 'en' || q === 'fr') return q;
    try {
        return localStorage.getItem('pf-lang') === 'en' ? 'en' : 'fr';
    } catch {
        return 'fr';
    }
}

function setLang(lang: Lang) {
    try {
        localStorage.setItem('pf-lang', lang);
    } catch {}
    const url = new URL(window.location.href);
    url.searchParams.set('lang', lang);
    window.history.replaceState(null, '', url);
    listeners.forEach((l) => l());
}

function subscribe(cb: () => void) {
    listeners.add(cb);
    return () => listeners.delete(cb);
}

export function useLang() {
    const lang = useSyncExternalStore(subscribe, read, () => 'fr' as Lang);
    return { lang, t: (x: T) => x[lang], setLang };
}

export function LangToggle() {
    const { lang } = useLang();
    return (
        <div className="inline-flex rounded-full border border-current/25 p-1 text-xs font-medium tracking-[0.18em]">
            {(['fr', 'en'] as const).map((l) => (
                <button
                    key={l}
                    onClick={() => setLang(l)}
                    aria-pressed={lang === l}
                    className={`rounded-full px-3 py-1.5 uppercase transition-colors ${lang === l ? 'bg-(--pf-ink) text-(--pf-paper)' : 'hover:text-(--pf-wine)'}`}
                >
                    {l}
                </button>
            ))}
        </div>
    );
}
